<template>
  <div>
    <!-- <GlobalHeader title="Customer Statement Print" style="padding-bottom:5px;"></GlobalHeader> -->
    <b-row v-show="!show_full_layout" class="px-3 border-bottom">
      <b-col cols="12" class="px-0">
        <h2
          class="custom-page-title mb-2 mt-1 px-4"
          style="position:relative;bottom:4px;"
        >Customer Statement Print</h2>
      </b-col>
    </b-row>
    <div
      class="sidenav-view-block py-4"
      style="padding-left:17px !important;padding-right:17px !important;overflow-y: scroll;height: calc(100vh - 92px);overflow-x:hidden;"
    >
      <b-row style="max-width:1440px;padding-bottom: 20px !important;">
        <b-col lg="6" xl="4" md="6" sm="6" xs="12">
          <div
            class="h-100"
            style="box-shadow: rgba(0, 0, 0, 0.09) 0px 0px 0.2cm;position:relative"
          >
            <div
              class="ribbon text-ellipsis popovercontainer disabled d-print-none"
              style="z-index:3;"
            >
              <div
                style="background-color:#fec44b;border-color:#fec44b"
                class="ribbon-inner font-weight-bold"
              >Active</div>
            </div>
            <Widget class="h-100 mb-0 text-center" title="Standard Template">
              <img
                src="@/assets/print/customer-statement.png"
                style="width:250px;height:350px;display:block;margin-left: auto;margin-right: auto;"
              />
              <div class="mt-3" style="text-align: center;">
                <b-button
                  v-if="RoutePermission(false,'','invoice','settings','templates')"
                  :to="{name:'CustomerTemplateUpdate',params:{id:7,path:path}}"
                  variant="outline-default"
                  size="sm"
                  class="text-dark"
                >
                  <i class="la la-edit la-lg"></i>
                </b-button>
              </div>
            </Widget>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import Widget from "@/components/Widget/Widget";
export default {
  components: {
    Widget
  },
  props: ["show_full_layout","path"]
};
</script>
